import { axiosInstance } from "../utils/AxiosInterceptor";

const getAllProductsByCategory = async () =>
  axiosInstance.get("productByCategory", { timeout: 300000 });

const getAllCategories = async () =>
  axiosInstance.get("category", { timeout: 300000 });

const getAllProducts = async () =>
  axiosInstance.get("product", { timeout: 300000 });

export { getAllProductsByCategory, getAllCategories, getAllProducts };

